import {
  getA1DashboardApi,
  getA1DensityReport,
  getA2DashboardApi,
  getA3DashboardApi,
  getA4DashboardApi,
  getA5DashboardApi,
} from '@/services/insights';
import { useState } from 'react';

export default () => {
  const [a1DensityReportData, setA1DensityReportData] = useState<API.A1DensityReportItem[]>([]);
  const [densityReportLoading, setDensityReportLoading] = useState(false);

  // A1 Dashboard 相關狀態
  const [a1DashboardData, setA1DashboardData] = useState<API.A1DashboardResponse>();
  const [a1DashboardLoading, setA1DashboardLoading] = useState(false);

  // A2 相關狀態
  const [a2DashboardData, setA2DashboardData] = useState<API.A2DashboardResponse>();
  const [a2DashboardLoading, setA2DashboardLoading] = useState(false);

  // A3 相關狀態
  const [a3DashboardData, setA3DashboardData] = useState<API.A3DashboardResponse>();
  const [a3DashboardLoading, setA3DashboardLoading] = useState(false);

  // A4 相關狀態
  const [a4DashboardData, setA4DashboardData] = useState<any>();
  const [a4DashboardLoading, setA4DashboardLoading] = useState(false);

  // A5 相關狀態
  const [a5DashboardData, setA5DashboardData] = useState<any>();
  const [a5DashboardLoading, setA5DashboardLoading] = useState(false);

  const getA1DensityReportData = async (
    params: API.A1InsightsGetParameters,
    options?: API.RequestOptions,
  ) => {
    setDensityReportLoading(true);
    return getA1DensityReport(params, options)
      .then((res) => {
        setA1DensityReportData(res);
        return res;
      })
      .finally(() => {
        setDensityReportLoading(false);
      });
  };

  // A1 Dashboard API 調用
  const getA1Dashboard = async (
    params: {
      start_date: string;
      end_date: string;
      client_id?: string;
    },
    options?: API.RequestOptions,
  ) => {
    setA1DashboardLoading(true);
    return getA1DashboardApi(params, options)
      .then((res) => {
        setA1DashboardData(res);
        return res;
      })
      .finally(() => {
        setA1DashboardLoading(false);
      });
  };

  // A2 Dashboard API 調用
  const getA2Dashboard = async (
    params: {
      start_date: string;
      end_date: string;
      client_id?: string;
    },
    options?: API.RequestOptions,
  ) => {
    setA2DashboardLoading(true);
    return getA2DashboardApi(params, options)
      .then((res) => {
        setA2DashboardData(res);
        return res;
      })
      .finally(() => {
        setA2DashboardLoading(false);
      });
  };

  // A3 Dashboard API 調用
  const getA3Dashboard = async (
    params: {
      start_date: string;
      end_date: string;
      client_id?: string;
    },
    options?: API.RequestOptions,
  ) => {
    setA3DashboardLoading(true);
    return getA3DashboardApi(params, options)
      .then((res) => {
        setA3DashboardData(res);
        return res;
      })
      .finally(() => {
        setA3DashboardLoading(false);
      });
  };

  // A4 Dashboard API 調用
  const getA4Dashboard = async (
    params: {
      start_date: string;
      end_date: string;
      client_id?: string;
    },
    options?: API.RequestOptions,
  ) => {
    setA4DashboardLoading(true);
    return getA4DashboardApi(params, options)
      .then((res) => {
        setA4DashboardData(res);
        return res;
      })
      .finally(() => {
        setA4DashboardLoading(false);
      });
  };

  // A5 Dashboard API 調用
  const getA5Dashboard = async (
    params: {
      start_date: string;
      end_date: string;
      client_id?: string;
    },
    options?: API.RequestOptions,
  ) => {
    setA5DashboardLoading(true);
    return getA5DashboardApi(params, options)
      .then((res) => {
        setA5DashboardData(res);
        return res;
      })
      .finally(() => {
        setA5DashboardLoading(false);
      });
  };

  return {
    getA1DensityReportData,
    a1DensityReportData,
    densityReportLoading,

    // A1 Dashboard (新版統一查詢)
    getA1Dashboard,
    a1DashboardData,
    a1DashboardLoading,

    // A2 相關
    getA2Dashboard,
    a2DashboardData,
    a2DashboardLoading,

    // A3 相關
    getA3Dashboard,
    a3DashboardData,
    a3DashboardLoading,

    // A4 相關
    getA4Dashboard,
    a4DashboardData,
    a4DashboardLoading,

    // A5 相關
    getA5Dashboard,
    a5DashboardData,
    a5DashboardLoading,
  };
};
